import { createFileRoute } from "@tanstack/react-router";
import { useContext } from "react";
import { z } from "zod";
import { IncidentPage } from "@/features/helpdesk/incident-page";
import { TenantSwitcherContext } from "@/features/tenant-switcher/tenant-switcher-context";
import { ensureElementVisible } from "@/lib/route-guards";

// Awaria zbiorcza (makieta): kilka zgłoszeń aptek, jedna odpowiedź do każdej z osobna.
const searchSchema = z.object({ id: z.number().int().positive().catch(0) });

export const Route = createFileRoute("/_auth/helpdesk/awaria")({
	// Ten sam element co skrzynka i czat — awaria jest częścią „Obsługi”.
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.helpdesk.obsluga", location.pathname);
	},
	validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
	component: IncidentRoute,
});

function IncidentRoute() {
	const { id } = Route.useSearch();
	// Inna organizacja albo awaria = świeży edytor: szkic nie przechodzi do aptek innej awarii.
	const tenant = useContext(TenantSwitcherContext)?.selectedTenantId ?? null;
	return <IncidentPage key={`${tenant}:${id}`} id={id} />;
}
